import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { deleteDocument } from "../../../Services/Document";

const DeleteDocument = ({ open, onClose, document_id, onSuccess }) => {
  const client = useQueryClient();
  const { mutate: removeDocument, isLoading } = useMutation(deleteDocument, {
    onSuccess: (response) => {
      if (response?.data?.response_code === 200) {
        toast.success(response?.data?.message);

        onClose();
        client.refetchQueries(["get-document"]);
        if (onSuccess) {
          onSuccess();
        }
      } else {
        toast.warning(response?.data?.message || "Failed to delete document");
      }
    },

    onError: (error) => {
      console.error("DELETE ERROR:", error?.response?.data || error);

      toast.error(
        error?.response?.data?.message || "Failed to delete document",
      );
    },
  });

  if (!open) return null;

  const handleDelete = () => {
    const payload = {
      doc_id: document_id?.id,
    };

    removeDocument(payload);
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 px-4">
      <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-2xl">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 className="text-xl font-semibold text-gray-800">
              Delete Document
            </h2>

            <p className="mt-1 text-sm text-gray-500">
              Are you sure you want to delete this document?
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="text-xl text-gray-400 hover:text-gray-700"
          >
            ✕
          </button>
        </div>

        <div className="mt-5 rounded-lg bg-gray-50 p-4">
          <p className="text-sm text-gray-500">Title</p>

          <p className="mt-2 break-all text-sm font-semibold text-gray-800">
            {document_id?.title || "-"}
          </p>
        </div>

        <div className="mt-4 rounded-lg border border-red-200 bg-red-50 p-4">
          <p className="text-sm text-red-600">
            This action cannot be undone. The selected document will be
            permanently deleted.
          </p>
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="rounded-lg border border-gray-300 px-5 py-2.5 text-sm font-semibold text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={handleDelete}
            disabled={isLoading || !document_id}
            className={`rounded-lg px-5 py-2.5 text-sm font-semibold text-white ${
              isLoading || !document_id
                ? "cursor-not-allowed bg-gray-400"
                : "bg-red-600 hover:bg-red-700"
            }`}
          >
            {isLoading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteDocument;
